import { render, staticRenderFns } from "./WalletTopupPage.vue?vue&type=template&id=7f5dd22e&scoped=true&"
import script from "./WalletTopupPage.vue?vue&type=script&lang=js&"
export * from "./WalletTopupPage.vue?vue&type=script&lang=js&"
import style0 from "./WalletTopupPage.vue?vue&type=style&index=0&id=7f5dd22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5dd22e",
  null
  
)

export default component.exports